import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TabButton from "../../design-system/Button/TabButton";
import Summary from "./Summary/Summary";
import Challenges from "./challenges/Challenges";
import TitleBarCaselet from "../../design-system/TitleBarCaselet";
import { Caselet as CaseletType, delete_user_data_from_client_side, get_user_data, isValidEpochTime } from "../../utils/common";
import { PDFDownloadLink } from "@react-pdf/renderer";
import CaseletPdf from "../../design-system/exportCaseletAsPdf/CaseletPdf";
// import { getCaseletFileInfo, getUnPublishedCaseletFileInfo, moveUnpublishedCaseletToPublishedDir, saveCaseletInQdrant } from "../../api";
import { initializeCaselet, updateCaselet, updateCaseletPublishedStatus } from "./caseletSlice";
import ErrorBoundary from "../../utils/ErrorBoundry";
import NoPage from "../NoPage";
import { RootState, AppDispatch } from "../../state/store";
import MultipleLoadingScreen from "../../design-system/MultipleLoadingScreen";
import { LoadingScreen } from "../thoughts/chat/LoadingScreen";
import CardVideo from "../../design-system/CardVideo";
import Alert from "../../design-system/Alert";
import { Tooltip } from "@material-tailwind/react";
import { getCaseletFileInfo, getUnPublishedCaseletFileInfo, moveUnpublishedCaseletToPublishedDir, saveCaseletInQdrant } from "../../api/axiosApi";

let caseletData: CaseletType = {} as CaseletType;
let publishedCaselet: boolean;

const Caselet: React.FC = () => {
    const [activeTabTitle, setActiveTabTitle] = useState("summary");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const location = useLocation();
    const pdfRef = useRef<HTMLDivElement>(null);
    const navigate = useNavigate();
    const { id } = useParams();
    const [showAlert, setShowAlert] = useState(false);
    const [isNewOptionCreated, setIsNewOptionCreated] = useState(false);
    const dispatch = useDispatch<AppDispatch>();
    const [newlyDecisionPointExist, setNewlyDecisionPointExist] = useState(false);
    let isPublished = !location.pathname.includes("unpublished-caselets");
    const [isLastChallengeEmpty, setIsLastChallengeEmpty] = useState(false);
    let caselet = useSelector((state: RootState) => state.caselet) as CaseletType;
    const [activeTab, setActiveTab] = useState(localStorage.getItem(`${caselet.id}activeTab`) || "summary");

    function handleChallengeDataFromChild(data: boolean) {
        setIsLastChallengeEmpty(data);
    }

    const handleDiscardChanges = () => {
        setIsNewOptionCreated(false);
        for (var key of Object.keys(localStorage)) {
            if (key.includes("Decision Point")||key.includes("unsavedChallenge")) {
                localStorage.removeItem(key);
            }
        }
        // const [activeTab, setActiveTab] = useState(localStorage.getItem(`${caselet.id}activeTab`)|| "summary");

        localStorage.removeItem(`${caselet.id}activeTab`);

        if (newlyDecisionPointExist) {
            if (Array.isArray(caselet.challenges) && caselet.challenges.length > 0) {
                const challengesCopy = [...caselet.challenges];
                challengesCopy.pop(); // Safely remove the last element from the copy
                const updatedCaselet = {
                    ...caselet,
                    challenges: challengesCopy
                };
                dispatch(updateCaselet({ ...caseletData, challenges: updatedCaselet.challenges }));
            }

            setNewlyDecisionPointExist(false);
        }
        setShowAlert(false);
        setActiveTab(activeTabTitle);
                localStorage.removeItem(`${caselet.id}decisionPointName`);

        localStorage.removeItem(`${caselet.id}isEmptyDecisionPointExist`);
    };
    const handleStayEditing = () => {
        setShowAlert(false);
        setNewlyDecisionPointExist(false);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (id) {
                    if (isValidEpochTime(id)) {
                        const caseletInfoResponse = isPublished ? await getCaseletFileInfo(id) : await getUnPublishedCaseletFileInfo(id);
                        // if (caseletInfoResponse.status === 401 || caseletInfoResponse.status === 422) {
                        //     delete_user_data_from_client_side();
                        //     navigate("/user_login");
                        // }
                        const data = await caseletInfoResponse.data;
                        if (localStorage.getItem(`${caselet.id}isEmptyDecisionPointExist`) === "true") {
                            data.challenges.push({
                                title: `Decision Point  ${data.challenges.length + 1}`,
                                challenge: "",
                                options: [],
                                videos: []
                            });
                        }
                        dispatch(initializeCaselet(data));
                        setLoading(false);
                    } else {
                        setLoading(false);
                        dispatch(initializeCaselet({} as CaseletType));
                        return <NoPage />;
                    }
                }
                setLoading(false);
            } catch (err) {
                setError("Invalid Caselet Id");
                dispatch(initializeCaselet({} as CaseletType));
                setLoading(false);
                return <NoPage />;
            }
        };

        fetchData();
    }, [id, dispatch, isPublished]);

    useEffect(() => {
        return () => {
            localStorage.removeItem(`${caselet.id}decisionPointName`);
            localStorage.removeItem(`${caselet.id}isEmptyDecisionPointExist`);
            localStorage.removeItem(`${caselet.id}activeTab`);
        };
    }, []);
    if (loading) {
        return <MultipleLoadingScreen count={1} />;
    }

    if (error) {
        return (
            <div>
                <CardVideo title="ERROR :" content={error} />
            </div>
        );
    }

    if (!caselet || Object.keys(caselet).length === 0) {
        return <NoPage />;
    }

    caseletData = caselet;
    publishedCaselet = caselet.published;
    const fileName = "caselet_" + caselet.id + ".pdf";

    function checkForNewOptionCreated(flag: boolean) {
        setIsNewOptionCreated(flag);
    }

    const handleTabClick = (tab: string) => {
        if (tab === activeTab) {
            return;
        }

        if (isNewOptionCreated) {
            if (caselet.challenges[caselet.challenges.length - 1].challenge === "") {
                setShowAlert(false);
            } else {
                setShowAlert(true);
            }
        }
        if (tab !== activeTab) {
            if (caselet.challenges[caselet.challenges.length - 1].challenge === "") {
                setNewlyDecisionPointExist(true);
                setActiveTabTitle(tab);
            } else if (!isNewOptionCreated) {
                setNewlyDecisionPointExist(false);
                setActiveTab(tab);
            }
        }

        setActiveTabTitle(tab);
    };

    const handlePublishCaseletClick = async () => {
        if (get_user_data() !== null && get_user_data() !== undefined) {
            await moveUnpublishedCaseletToPublishedDir(caselet.id);
            navigate(`/caselets/${caselet.id}`);
            dispatch(updateCaseletPublishedStatus({ caseletId: caselet.id, publishedStatus: true }));
            await saveCaseletInQdrant(caselet);
            window.location.reload();
        } else {
            navigate("/user_login");
        }
    };

    if (!caselet.summary && !caselet.challenges) {
        return <NoPage />;
    }

    return (
        <div className="p-4" ref={pdfRef} id="caselet">
            <ErrorBoundary fallback="Error Finding the Caselet !!">
                <div className="flex items-center tabs-title-grid-style min-w-96">
                    <div className="flex tabs-grid-style">
                        <div className="">
                            <TabButton tab="summary" activeTab={activeTab} onClick={() => handleTabClick("summary")}>
                                Summary
                            </TabButton>
                        </div>
                        <div className="pl-2">
                            <TabButton tab="challenges" activeTab={activeTab} onClick={() => handleTabClick("challenges")}>
                                Challenges
                            </TabButton>
                        </div>
                        <div className="pl-2">
                            <TabButton tab="relevance" activeTab={activeTab} onClick={() => handleTabClick("relevance")}>
                                Relevancy
                            </TabButton>
                        </div>
                    </div>
                    <div className="pl-2 title-grid-style w-full">
                        <TitleBarCaselet title={caselet.title} authorName={caselet.authorName} />
                    </div>
                </div>
                <div className="min-w-96">
                    {activeTab === "summary" && caselet.summary && <Summary summary={caselet.summary} published={caselet.published} />}
                    {activeTab === "challenges" && caselet.challenges && (
                        <Challenges
                            challenges={caselet.challenges}
                            published={caselet.published}
                            sendChallengeDataToParent={handleChallengeDataFromChild}
                            caseletId={caselet.id}
                            respForNewOptionCreated={checkForNewOptionCreated}
                        />
                    )}
                    {activeTab === "relevance" && (
                        <div className="bg-white rounded-lg shadow-lg mt-4 p-4 ">
                            <div className="font-title ">
                                <p>Why the mentee should do this activity?</p>
                            </div>
                            <div className="mt-2">
                                <p>
                                    To help a coach to estimate how relevant this caselet is to a mentee. <br />
                                    The relevancy score will be a function of the mentee’s current strength, potential next state, outcome of peer mentees at
                                    similar state.
                                </p>
                            </div>
                        </div>
                    )}
                </div>
                <div className="flex mt-4  justify-between min-w-96">
                    <div>
                        <PDFDownloadLink document={<CaseletPdf />} fileName={fileName}>
                            {({ loading }) =>
                                loading ? (
                                    <button className=" text-gray-500">
                                        <LoadingScreen />
                                    </button>
                                ) : (
                                    // <button className="bg-green-700 text-white hover:bg-green-950 font-bold py-2 px-4 rounded">Export as PDF</button>
                                    <div>
                                        {caselet.challenges[caselet.challenges.length - 1].challenge === "" || isNewOptionCreated ? (
                                            <Tooltip
                                                content={"Save the changes to enable export button"}
                                                placement="bottom-start"
                                                className={`p-2 bg-gray-500 font-bold text-xs`}
                                            >
                                                <button
                                                    disabled={caselet.challenges[caselet.challenges.length - 1].challenge === "" || isNewOptionCreated}
                                                    className={`bg-green-700 text-white hover:bg-green-900 font-bold py-2 px-4 rounded ${
                                                        caselet.challenges[caselet.challenges.length - 1].challenge !== "" && !isNewOptionCreated
                                                            ? "opacity-100"
                                                            : "opacity-70 "
                                                    }`}
                                                >
                                                    Export as PDF
                                                </button>
                                            </Tooltip>
                                        ) : (
                                            <button className="bg-green-700 text-white hover:bg-green-900 font-bold py-2 px-4 rounded opacity-100">
                                                Export as PDF
                                            </button>
                                        )}
                                    </div>
                                )
                            }
                        </PDFDownloadLink>
                    </div>
                    {!isPublished && (
                        <div>
                            {caselet.challenges[caselet.challenges.length - 1].challenge === "" || isNewOptionCreated ? (
                                <Tooltip
                                    content={"Save the changes to enable publish button"}
                                    placement="bottom-start"
                                    className={`p-2 bg-gray-500 font-bold text-xs`}
                                >
                                    <button
                                        disabled={caselet.challenges[caselet.challenges.length - 1].challenge === "" || isNewOptionCreated}
                                        className={`bg-green-700 text-white hover:bg-green-900 font-bold py-2 px-4 rounded ${
                                            caselet.challenges[caselet.challenges.length - 1].challenge !== "" && !isNewOptionCreated
                                                ? "opacity-100"
                                                : "opacity-70 "
                                        }`}
                                        onClick={handlePublishCaseletClick}
                                    >
                                        Publish Caselet
                                    </button>
                                </Tooltip>
                            ) : (
                                <button
                                    className="bg-green-700 text-white hover:bg-green-900 font-bold py-2 px-4 rounded opacity-100"
                                    onClick={handlePublishCaseletClick}
                                >
                                    Publish Caselet
                                </button>
                            )}
                        </div>
                    )}
                </div>
                <Alert showAlert={showAlert || newlyDecisionPointExist} handleStayEditing={handleStayEditing} handleDiscardChanges={handleDiscardChanges} />
            </ErrorBoundary>
        </div>
    );
};

export { Caselet, caseletData, publishedCaselet };
